
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 2v7.5","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M4.75 6.75L8 10l3.25-3.25","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.75 11.5v1a1.5 1.5 0 001.5 1.5h7.5a1.5 1.5 0 001.5-1.5v-1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    